<template>
    <div v-if="subconta" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Subconta</h4>
        <router-link to="/financeiro/subcontas">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <!-- Seção 1 -->
        <FormSection title="">
          <p><strong>Nome:</strong> {{ subconta.nome || 'Não informado' }}</p>
          <p><strong>Plano de Contas:</strong> {{ subconta.plano_de_contas || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(subconta?.ativo) }}</p>
        </FormSection>
  
        <!-- Seção 2 -->
        <FormSection title="">
          <p><strong>Descrição:</strong> {{ subconta.descricao || 'Não informado' }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        subconta: null,
      };
    },
    methods: {
      async carregarDetalhesSubconta() {
        try {
          const response = await axios.get(
            `/financeiro/subcontas/${this.$route.params.id}`
          );
          this.subconta = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes da subconta:", error);
        }
      },
  
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          return "Não informado";
        }
        return valor ? "Ativo" : "Inativo";
      },
    },
    mounted() {
      this.carregarDetalhesSubconta();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%; /* Ajustado para centralizar melhor */
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  